import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'lokos-filter-chip',
    templateUrl: './filter-chip.component.html',
    styleUrl: './filter-chip.component.scss',
    standalone: false,
})
export class FilterChipComponent {
    @Input() label = '';
    @Output() remove = new EventEmitter<void>();

    onRemove() {
        this.remove.emit();
    }
}
